import { Component, OnInit } from '@angular/core';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';

@Component({
  selector: 'app-privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.scss']
})
export class PrivacyPolicyComponent implements OnInit {
  seoDes: string = '';

  constructor(
    private gobalFunctionService: GobalFunctionService
  ) { }

  ngOnInit(): void {
    this.gobalFunctionService.setSEO('นโยบายความเป็นส่วนตัว', 'website', '');
  }

}
